<div class="main-content-wrapper">

  <div class="step-items-wrapper">
    <nz-steps [nzCurrent]="stepIndex" (nzIndexChange)="onIndexChange($event)">
      <nz-step nzTitle="Event Details" nzDescription="Provide basic information for the cover page."></nz-step>
      <nz-step nzTitle="Submission" nzDescription="Choose or update vendor submission."
        [nzDisabled]="!validateForm.valid"></nz-step>
      <nz-step nzTitle="Photos" nzDescription="Choose or upload photos from submission."
        [nzDisabled]="!vendorSubmissionsForm.valid || !validateForm.valid"></nz-step>
      <nz-step nzTitle="Review & Generate" [nzDisabled]="!vendorSubmissionsForm.valid || !validateForm.valid"
        nzDescription="Review all details before generating the final output."></nz-step>
    </nz-steps>
  </div>


  <div class="step-content">

    <div *ngIf="stepIndex === 0" class="event-details-form-container">
      <h2>Event Details</h2>
      <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventName" nzRequired>Event Name</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please input your Event Name!">
            <input nz-input formControlName="eventName" id="eventName" placeholder="Enter Event Name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventStartDate" nzRequired>Event Start Date</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please enter the Event Start Date!">
            <input nz-input type="text" formControlName="eventStartDate" id="eventStartDate"
              placeholder="e.g., 11th September, 2050" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item nz-row class="register-area">
          <nz-form-control [nzSpan]="14" [nzOffset]="6">
            <label nz-checkbox formControlName="includeCoverPage">
              <span>Include Cover Page</span>
            </label>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item nz-row class="register-area">
          <nz-form-control [nzSpan]="14" [nzOffset]="6">
            <label nz-checkbox formControlName="includeThankYouPage">
              <span>Include Thank You Page</span>
            </label>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item nz-row class="register-area">
          <nz-form-control [nzSpan]="14" [nzOffset]="6">
            <button nz-button nzType="primary" [disabled]="!validateForm.valid">Next</button>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>

    <div *ngIf="stepIndex === 1" class="vendor-submissions-container">
      <h2>Vendor Submission</h2>

      <div *ngIf="vendorSubmissionsForm && vendorsFormArray.length > 0">
        <form nz-form [formGroup]="vendorSubmissionsForm" (ngSubmit)="submitForm()">
          <ng-container formArrayName="vendors">
            <nz-collapse>
              <nz-collapse-panel *ngFor="let vendorGroup of vendorsFormArray.controls; let i = index"
                [nzHeader]="vendorGroupTitle" [formGroupName]="i">
                <ng-template #vendorGroupTitle>
                  <h3 style="margin-bottom: 0px;"><strong>{{'Vendor ' + (i + 1) + ': ' +
                        vendorGroup.get('vendorName')?.value}}</strong></h3>
                </ng-template>
                <nz-form-item>
                  <nz-form-label [nzFor]="'vendorName' + i">Name</nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24"
                    [nzValidateStatus]="vendorGroup.get('vendorName')?.invalid && (vendorGroup.get('vendorName')?.dirty || vendorGroup.get('vendorName')?.touched) ? 'error' : null"
                    nzErrorTip="Please enter vendor name!">
                    <input nz-input formControlName="vendorName" [id]="'vendorName' + i" />
                  </nz-form-control>
                </nz-form-item>

                <div class="answers-table-container">
                  <nz-table #answersTable [nzData]="getAnswersFormArray(i).controls" [nzPageSize]="10" nzSize="middle"
                    [nzShowPagination]="false">
                    <thead>
                      <tr>
                        <th nzWidth="50px">Include</th>
                        <th>Question</th>
                        <th>Answer</th>
                        <th nzWidth="50px">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let answerGroup of getAnswersFormArray(i).controls; let j = index; track j;">
                        <td>
                          <label nz-checkbox [ngModel]="getAnswerSelected(i, j)"
                            (ngModelChange)="setAnswerSelected(i, j, $event)" [ngModelOptions]="{standalone: true}">
                          </label>
                        </td>

                        <td>
                          <nz-form-item nzNoColon class="answer-form-item">
                            <nz-form-control
                              [nzValidateStatus]="getAnswerControl(i, j, 'questionText').invalid && (getAnswerControl(i, j, 'questionText').dirty || getAnswerControl(i, j, 'questionText').touched) ? 'error' : null"
                              nzErrorTip="Question text is required!">
                              <textarea nz-input rows="2" [ngModel]="getAnswerQuestionText(i, j)"
                                (ngModelChange)="setAnswerQuestionText(i, j, $event)"
                                [ngModelOptions]="{standalone: true}" placeholder="Question Text">
                              </textarea>
                            </nz-form-control>
                          </nz-form-item>
                        </td>

                        <td>
                          <nz-form-item nzNoColon class="answer-form-item">
                            <nz-form-control *ngIf="typeof getAnswerAnswerText(i, j) !== 'object'"
                              [nzValidateStatus]="getAnswerControl(i, j, 'answerText').invalid && (getAnswerControl(i, j, 'answerText').dirty || getAnswerControl(i, j, 'answerText').touched) ? 'error' : null"
                              nzErrorTip="Answer text is required!">
                              <textarea nz-input rows="2" [ngModel]="getAnswerAnswerText(i, j)"
                                (ngModelChange)="setAnswerAnswerText(i, j, $event)"
                                [ngModelOptions]="{standalone: true}" placeholder="Answer Text">
                               </textarea>
                            </nz-form-control>
                            <div *ngIf="typeof getAnswerAnswerText(i, j) === 'object'" class="answer-object-display">
                              <em>(Complex data, not editable here)</em>
                              <pre>{{ getAnswerAnswerText(i, j) | json }}</pre>
                            </div>
                          </nz-form-item>
                        </td>
                        <td>
                          <button nz-button nzDanger nzSize="small" nzShape="circle" nzTooltipTitle="Remove"
                            nzTooltipPlacement="top" (click)="removeCustomAnswer(i, j)"
                            [disabled]="getAnswerControl(i, j, 'originalAnswerId').value !== null" type="button">
                            <i nz-icon nzType="delete" nzTheme="fill"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </nz-table>
                  <div class="text-right" style="margin-top: 10px;">
                    <button nz-button nzType="dashed" (click)="addCustomAnswer(i)" type="button">
                      <i nz-icon nzType="plus"></i> Add Custom Question
                    </button>
                  </div>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
          </ng-container>


          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <button nz-button nzType="primary" [disabled]="!vendorSubmissionsForm.valid" type="submit">Next</button>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

    </div>

    <div *ngIf="stepIndex === 2" class="vendor-photos-container">
      <h2>Vendor Photos</h2>
      <div *ngIf="vendorSubmissionsForm && vendorsFormArray.length > 0">
        <form nz-form [formGroup]="vendorSubmissionsForm">
          <ng-container formArrayName="vendors">
            <nz-collapse>
              <nz-collapse-panel *ngFor="let vendorGroup of vendorsFormArray.controls; let i = index"
                [nzHeader]="vendorPhotoGroupTitle" [formGroupName]="i" [nzActive]="true">
                <ng-template #vendorPhotoGroupTitle>
                  <h3 style="margin-bottom: 0px;"><strong>{{'Vendor ' + (i + 1) + ': ' +
                        vendorGroup.get('vendorName')?.value}}</strong></h3>
                </ng-template>

                <nz-form-item class="mb-3">
                  <nz-form-label [nzSm]="6" [nzXs]="24" [nzFor]="'sectionHeading' + i">Section Heading</nz-form-label>
                  <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please provide a section heading!">
                    <input nz-input [formControlName]="'sectionHeading'" [id]="'sectionHeading' + i"
                      placeholder="Enter Section Heading" />
                  </nz-form-control>
                </nz-form-item>
                <div class="photos-table-container">
                  <nz-table #photosTable [nzData]="getPhotosFormArray(i).controls" [nzPageSize]="10" nzSize="middle"
                    [nzShowPagination]="false">
                    <thead>
                      <tr>
                        <th nzWidth="50px">Include</th>
                        <th>Photo</th>
                        <th>File Name</th>
                        <th nzWidth="50px">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let photoGroup of getPhotosFormArray(i).controls; let j = index;">
                        <td>
                          <label nz-checkbox [ngModel]="getPhotoSelected(i, j)"
                            (ngModelChange)="setPhotoSelected(i, j, $event)" [ngModelOptions]="{standalone: true}">
                          </label>
                        </td>
                        <td>
                          <img nz-image [nzSrc]="getPhotoBase64Content(i, j) || getPhotoFileUrl(i, j)"
                            alt="Photo Preview"
                            style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; border: 1px solid #e8e8e8;" />
                        </td>
                        <td>{{ getPhotoFileName(i, j) }}</td>
                        <td>
                          <button nz-button nzDanger nzSize="small" nzShape="circle" nzTooltipTitle="Remove"
                            nzTooltipPlacement="top" (click)="removePhoto(i, j)"
                            [disabled]="getPhotoControl(i, j, 'originalFileReferenceId').value !== null || getPhotoControl(i, j, 'fileUrl').value !== ''"
                            type="button">
                            <i nz-icon nzType="delete" nzTheme="fill"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </nz-table>
                  <div *ngIf="getSelectedPhotoCount(i) > 4" class="photo-limit-error" style="color: #ff4d4f; margin-top: 8px; margin-bottom: 4px; font-size: 13px;">
                    <i nz-icon nzType="exclamation-circle" nzTheme="fill" style="margin-right: 4px;"></i>
                    Maximum 4 photos can be selected per vendor. Please deselect {{ getSelectedPhotoCount(i) - 4 }} photo(s).
                  </div>
                  <div class="text-right" style="margin-top: 10px;">
                    <label nz-button nzType="dashed">
                      <input type="file" (change)="onFileSelected($event, i)" accept="image/*" style="display: none;" />
                      <i nz-icon nzType="upload"></i> Upload Custom Photo
                    </label>
                  </div>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
          </ng-container>

          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <button nz-button nzType="primary" (click)="submitForm()" [disabled]="hasPhotoLimitExceeded()">Next</button>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>
      <ng-template #noPhotosAvailable>
        <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No photos found for any vendor."></nz-empty>
      </ng-template>
    </div>


    <div *ngIf="stepIndex === 3" class="review-generate-container">
      <h2>Review & Generate</h2>

      <h3>Event Details:</h3>
      <nz-descriptions nzBordered nzSize="small" [nzColumn]="2">
        <nz-descriptions-item nzTitle="Event Name">{{ reviewData.eventDetails?.eventName }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Event Start Date">{{ reviewData.eventDetails?.eventStartDate
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Include Cover Page">{{ reviewData.eventDetails?.includeCoverPage ? 'Yes' : 'No'
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Include Thank You Page">{{ reviewData.eventDetails?.includeThankYouPage ? 'Yes' :
          'No' }}</nz-descriptions-item>
      </nz-descriptions>

      <h3 class="mt-4">Vendor Submissions:</h3>
      <div *ngIf="reviewData.vendorSubmissions?.vendors?.length > 0; else noVendorSubmissions">

        <ng-container>
          <nz-collapse>
            <nz-collapse-panel *ngFor="let vendor of reviewData.vendorSubmissions.vendors; let i = index"
              [nzHeader]="vendorGroupTitleReview">

              <ng-template #vendorGroupTitleReview>
                <h3 style="margin-bottom: 0px;"><strong>{{vendor.vendorName}}</strong></h3>
              </ng-template>

              <h4>Vendor {{ i + 1 }}: <span class="vendor-name-display">{{ vendor.vendorName }}</span></h4>
              <p><strong>Section Heading:</strong> {{ vendor.sectionHeading }}</p>

              <h5>Answers:</h5>
              <nz-table #reviewAnswersTable [nzData]="vendor.answers" [nzPageSize]="5" nzSize="middle"
                [nzShowPagination]="false">
                <thead>
                  <tr>
                    <th nzWidth="50px">Included</th>
                    <th>Question</th>
                    <th>Answer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let answer of vendor.answers">
                    <td>
                      <span *ngIf="answer.selected">✅</span>
                      <span *ngIf="!answer.selected">❌</span>
                    </td>
                    <td>{{ answer.questionText }}</td>
                    <td>{{ answer.answerText }}</td>
                  </tr>
                </tbody>
              </nz-table>

              <h5 class="mt-3">Photos:</h5>
              <div *ngIf="vendor.photos && vendor.photos.length > 0; else noPhotosForVendor">
                <nz-table [nzData]="vendor.photos" [nzPageSize]="5" nzSize="middle" [nzShowPagination]="false">
                  <thead>
                    <tr>
                      <th nzWidth="50px">Included</th>
                      <th>Photo</th>
                      <th>File Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let photo of vendor.photos">
                      <td>
                        <span *ngIf="photo.selected">✅</span>
                        <span *ngIf="!photo.selected">❌</span>
                      </td>
                      <td>
                        <img nz-image [nzSrc]="photo.base64Content || getHttpsUrl(photo.fileUrl)"
                          alt="Photo Preview"
                          style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; border: 1px solid #e8e8e8;" />
                      </td>
                      <td>{{ photo.fileName }}</td>
                    </tr>
                  </tbody>
                </nz-table>
              </div>
              <ng-template #noPhotosForVendor>
                <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No photos selected for this vendor."></nz-empty>
              </ng-template>

            </nz-collapse-panel>

          </nz-collapse>
        </ng-container>


      </div>
      <ng-template #noVendorSubmissions>
        <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No vendor submissions to review."></nz-empty>
      </ng-template>

      <div class="text-center mt-4">
        <button nz-button nzType="primary" nzSize="large" (click)="onDownloadPpt()" [nzLoading]="isLoading">
          <i nz-icon nzType="download"></i> Download PPT
        </button>
      </div>
    </div>
  </div>
</div>
